/* eslint-disable camelcase */
import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import Modal from '../../component/Modal/Modal';
import CButton from '../../component/Button';
import { CStandardInput } from '../../component/Input';

const useStyles = makeStyles({
  garbage: {
    cursor: 'pointer',
    left: '8px',
    position: 'absolute',
    top: '0px'
  },
  keyWrapper: {
    '& p': {
      margin: '0px'
    },
    alignItems: 'center',
    display: 'flex'
  },
  removeButton: {
    background: 'transparent',
    border: 'none',
    boxShadow: 'none',
    cursor: 'pointer',
    display: 'inline-block',
    margin: '0',
    padding: '0',
    width: '18px'
  },
  root: {
    ' & .MuiInputBase-root': {
      border: '1px solid #CAD8FF',
      borderRadius: '12px',
      color: 'black',
      padding: '12.75px 16px'
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: '#9BA0AD'
    },
    '& .MuiInput-inputMultiline': {
      alignItems: 'flex-start',
      height: '110px'
    },
    '& .MuiInput-underline:before': {
      display: 'none'
    },
    '& .MuiInputBase-input': {
      fontSize: '12px',
      padding: '0px'
    },

    '& .MuiInputLabel-formControl': {
      fontSize: '12px',
      left: '10px',
      top: '7px'
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(-10px, -10px) scale(0.83)'
    }
  }
});

// const { SubMenu } = Menu;
// const { Header, Content, Footer, Sider } = Layout;
// const { Title, Text } = Typography;

const FieldSettings = ({
  fieldType,
  visible,
  onCancel,
  onOk,
  field_addition,
  nameField,
  label,
  oldFieldAddition,
  onFieldKeyRemove
}) => {
  const classes = useStyles();
  const [fieldName, setFieldName] = useState(label);
  const [fieldId, setFieldId] = useState(nameField);
  const [limit, setLimit] = useState(field_addition?.characterLimit);
  const [objectData, setObjectData] = useState({ ...oldFieldAddition });
  const [selectData, setSelectData] = useState(oldFieldAddition?.selectData);
  const [objectKey, setObjectKey] = useState('');
  const [selectElement, setSelectElement] = useState('');
  const [showObjectModal, setShowObjectModal] = useState(false);
  const objectKeys = Object.keys(objectData);

  const onModalCancel = () => {
    setObjectData({ ...oldFieldAddition });
    setSelectData(oldFieldAddition.selectData);
    setObjectKey('');
    onCancel();
  };

  const getPropsForFieldType = () => {
    switch (fieldType) {
      case 'text':
        return { characterLimit: Number(limit), hint: '' };

      case 'complex list':
        return { ...objectData };

      case 'Select':
        return { selectData: [...selectData] };

      default:
        return {};
    }
  };

  const onConfirm = () => {
    const props = getPropsForFieldType();

    onOk({
      apiId: fieldId,
      name: fieldName,
      oldApiId: nameField,
      props,
      type: fieldType
    });
    setFieldName(label);
    setFieldId(nameField);
    setLimit(field_addition?.characterLimit);
    setObjectKey('');
  };

  function addObjectKey() {
    setObjectData((oldData) => {
      return { ...oldData, [objectKey]: '' };
    });
    setObjectKey('');
  }

  function addSelectElement() {
    setSelectData((oldData) => {
      return [...oldData, selectElement];
    });
    setSelectElement('');
  }

  // eslint-disable-next-line no-unused-vars
  function removeSelectElement(index) {
    const selectDataCopy = [...selectData];
    selectDataCopy.splice(index, 1);
    setSelectData(selectDataCopy);
  }

  function removeKey(key) {
    const newObj = { ...objectData };
    delete newObj[key];
    setObjectData(newObj);
    onFieldKeyRemove(fieldId, key);
  }

  return (
    <div>
      <Modal
        footerActions={
          <>
            <CButton key="back" onClick={onModalCancel}>
              Cancel
            </CButton>
            <CButton key="submit" onClick={onConfirm} type="primary">
              Save
            </CButton>
          </>
        }
        handleClose={onModalCancel}
        isModalOpen={visible}
        styles={{
          '& .MuiDialogContent-root': {
            display: 'flex',
            flexDirection: 'column',
            height:
              fieldType === 'text' || fieldType === 'complex list' || fieldType === 'Select'
                ? 270
                : 200,
            justifyContent: 'space-between',
            paddingBottom: '24px'
          },
          width: '560px'
        }}
        titleContent={<span className="modal-title">Configure</span>}
      >
        <CStandardInput
          disableUnderline
          formclasses={{ root: classes.root }}
          htmlFor="standard-input-content-model-detail-name"
          id="standard-input-content-model-detail-name"
          label="Name"
          onChange={(e) => setFieldName(e.target.value)}
          size="large"
          value={fieldName}
          width="true"
        />

        <CStandardInput
          disableUnderline
          formclasses={{ root: classes.root }}
          htmlFor="standard-input-content-model-detail-id"
          id="standard-input-content-model-detail-id"
          label="Field Id"
          onChange={(e) => setFieldId(e.target.value)}
          size="large"
          value={fieldId}
          width="true"
        />
        {fieldType === 'text' && (
          <CStandardInput
            allowClear={false}
            disableUnderline
            formclasses={{ root: classes.root }}
            htmlFor="standard-input-content-model-detail-text-limit"
            id="standard-input-content-model-detail-text-limit"
            label="Character Limit"
            onChange={(e) => setLimit(e.target.value)}
            size="large"
            type="number"
            value={limit}
            width="true"
          />
        )}
        {fieldType === 'complex list' && (
          <>
            <div
              style={{
                alignItems: 'flex-end',
                display: 'flex'
              }}
            >
              <CStandardInput
                allowClear
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-content-model-detail-object-key"
                id="standard-input-content-model-detail-object-key"
                label="object key"
                onChange={(event) => setObjectKey(event.target.value)}
                size="large"
                value={objectKey}
                width="true"
              />
              <CButton onClick={addObjectKey} size="large" type="primary">
                Add
              </CButton>
              <CButton onClick={() => setShowObjectModal(true)} size="large" type="primary">
                View
              </CButton>
            </div>
            {showObjectModal && (
              <Modal
                handleClose={() => setShowObjectModal(false)}
                isModalOpen={showObjectModal}
                styles={{
                  '& .MuiDialogContent-root': {
                    padding: '8px 24px 24px'
                  },
                  minHeight: '187px',
                  width: '460px'
                }}
                titleContent={<h2 className="modal-title">Keys</h2>}
              >
                {objectKeys.map((key, index) => {
                  return (
                    <div key={index} className={classes.keyWrapper}>
                      <button
                        className={classes.removeButton}
                        onClick={() => removeKey(key)}
                        type="button"
                      >
                        x
                      </button>
                      <p>{key}</p>
                    </div>
                  );
                })}
              </Modal>
            )}
          </>
        )}

        {fieldType === 'Select' && (
          <>
            <div
              style={{
                alignItems: 'flex-end',
                display: 'flex'
              }}
            >
              <CStandardInput
                allowClear
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-content-model-detail-object-key"
                id="standard-input-content-model-detail-object-key"
                label="object key"
                onChange={(event) => setSelectElement(event.target.value)}
                size="large"
                value={selectElement}
                width="true"
              />
              <CButton onClick={addSelectElement} size="large" type="primary">
                Add
              </CButton>
              <CButton onClick={() => setShowObjectModal(true)} size="large" type="primary">
                View
              </CButton>
            </div>
            {showObjectModal && (
              <Modal
                handleClose={() => setShowObjectModal(false)}
                isModalOpen={showObjectModal}
                styles={{
                  '& .MuiDialogContent-root': {
                    padding: '8px 24px 24px'
                  },
                  minHeight: '187px',
                  width: '460px'
                }}
                titleContent={<h2 className="modal-title">Keys</h2>}
              >
                {selectData.length
                  ? selectData.map((selectedDataElement, index) => {
                      return (
                        <div key={index} className={classes.keyWrapper}>
                          <button
                            className={classes.removeButton}
                            onClick={() => removeSelectElement(index)}
                            type="button"
                          >
                            x
                          </button>
                          <p>{selectedDataElement}</p>
                        </div>
                      );
                    })
                  : null}
              </Modal>
            )}
          </>
        )}
      </Modal>
    </div>
  );
};

export default FieldSettings;
